<template>
  <div style="overflow-y: hidden;">
    <v-menu
      v-for="item in fileList"
      :key="item.docCode"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          outlined
          tile
          :ripple="item.docType === 'PA'"
          v-bind="attrs"
          class="mr-1 mb-1 pa-1 py-3"
          v-on="on"
          @click="getInfo(item)"
        >
          <v-icon color="blue darken-3">
            {{ mdiFileDocumentOutline }}
          </v-icon>
          {{ item.docName }}
          <v-icon
            v-if="item.docType === 'PA'"
          >
            {{ mdiMenuDown }}
          </v-icon>
        </v-btn>
      </template>
      <v-list
        v-if="item.docType === 'PA'"
        dense
      >
        <v-list-item @click="markAsDeletedFile(item.docCode)">
          <v-list-item-title>
            <v-icon
              small
              class="mr-1"
              color="red"
            >
              {{ mdiClose }}
            </v-icon>
            {{ $t('eDocInternal.deleteAttachment') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title v-if="attachmentInfo">
            {{ $chPtObjData('chinName', attachmentInfo) }} ({{ momentWithHyphen(attachmentInfo.createdTime).format('YYYY-MM-DD HH:mm') }})
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>

import docFlowApi from '@/api/eDocInternal/docFlow'
import { DOC_FLOW_ACTION_TYPE, DOC_FLOW_FILE_TYPE } from '@/constant/constant'
import { mdiFileDocumentOutline, mdiMenuDown, mdiClose } from '@mdi/js'
// import { buildStaffList } from '@/utils/utils'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { momentWithHyphen } from '@/utils/datetimeUtil'

export default {
  components: {

  },
  mixins: [docFlowMethod],
  props: {
    processId: {
      type: Number,
      required: true
    },
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
    passFileList: { // files which will pass to next staff
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      mdiClose: mdiClose,
      mdiMenuDown: mdiMenuDown,
      mdiFileDocumentOutline: mdiFileDocumentOutline,
      attachmentInfo: null
    }
  },
  async created () {
    // this.uploadFileUrl = docFlowApi.uploadFileUrl
    // this.form.dfProcessId = this.edoc.dfProcessId
    // await docFlowApi.getProcessPrefillInfo(this.edoc.dfProcessId, resp => {
    //   this.prefillInfo = resp.data
    // })

    // if (this.prefillInfo) {
    // this.prefillInfo.preFilledReceiverTOList.forEach(obj => {
    //   this.euids.push(obj.euid)
    // })
    // this.form.senderInstruction = this.prefillInfo.prefilledInstruction
    // this.form.senderNote = this.prefillInfo.prefilledNote
    this.fileList.forEach(obj => {
      if (obj.docType === DOC_FLOW_FILE_TYPE.REFERENCE) {
        this.passFileList.push({
          docCode: obj.docCode,
          docName: obj.docName,
          actionType: DOC_FLOW_ACTION_TYPE.FORWARD,
          id: null
        })
      }
    })
    this.$emit('update:passFileList', this.passFileList)
    // }
  },
  methods: {
    markAsDeletedFile: function (docCode) {
      let index = 0
      index = this.fileList.findIndex(obj => obj.docCode === docCode)
      this.fileList.splice(index, 1)
      this.passFileList.forEach(obj => {
        if (obj.docCode === docCode) {
          obj.actionType = DOC_FLOW_ACTION_TYPE.DELETE
        }
      })
      this.$emit('update:passFileList', this.passFileList)
    },
    getInfo (item) {
      this.attachmentInfo = null
      if (item.docType === 'PA') {
        docFlowApi.getProcessAttachmentCreateInfo(this.processId, item.docCode, resp => {
          this.attachmentInfo = resp.data
        })
      }
    },

    momentWithHyphen
  }
}
</script>
